import "./EmptyOrders.css";

import {
  MdShoppingBag,
  MdRefresh,
} from "react-icons/md";

function EmptyOrders({ onRefresh }) {
  return (
    <div className="empty-orders">

      <div className="empty-orders-icon">
        <MdShoppingBag />
      </div>

      <h2>No Orders Yet</h2>

      <p>
        New customer orders will appear here once they are placed.
      </p>

      <button
        className="empty-refresh-btn"
        onClick={onRefresh}
      >
        <MdRefresh />
        Refresh
      </button>

    </div>
  );
}

export default EmptyOrders;